import Page from './Page.js';

/**
 * Class Realisation
 */
class Realisation extends Page{


  /**
   * Constructor
   */
  constructor(currentPageId, postId){
    super();
    // Properties
    this.currentPageId = currentPageId;
    this.postId = postId
    this.data = {};
  }


  /**
   * Init
   */
  init(){

  }


  /**
   * Set realisations events listeners
   */
  setEventsListeners() {
    console.log('set realisation events listeners');
    if(document.getElementById("realisation-goto-shops-border-fill-button")){
      document.getElementById("realisation-goto-shops-border-fill-button")
        .addEventListener(
        "click",
        this.clickOnRealisationGotoRealisations,
        false
      );
    }
    if(document.getElementById("nav-p")){
      document.getElementById("nav-p")
        .addEventListener(
        "click",
        this.clickOnRealisationGotoPrevious,
        false
      );
    }
    if(document.getElementById("nav-n")){
      document.getElementById("nav-n")
        .addEventListener(
        "click",
        this.clickOnRealisationGotoNext,
        false
      );
    }
  }


  /**
   * Unset realisations event listeners
   */
  unsetEventsListeners() {
    console.log('unset realisation events listeners');
    if(document.getElementById("realisation-goto-shops-border-fill-button")){
      document.getElementById("realisation-goto-shops-border-fill-button")
        .removeEventListener(
        "click",
        this.clickOnRealisationGotoRealisations,
        false
      );
    }
    if(document.getElementById("nav-p")){
      document.getElementById("nav-p")
        .removeEventListener(
        "click",
        this.clickOnRealisationGotoPrevious,
        false
      );
    }
    if(document.getElementById("nav-n")){
      document.getElementById("nav-n")
        .removeEventListener(
        "click",
        this.clickOnRealisationGotoNext,
        false
      );
    }
  }


  /**
   * click on realisation goto realisations
   */
  clickOnRealisationGotoRealisations(e) {
    e.preventDefault();
    console.log('pass in click on realisation goto realisations link');
    // @TODO: Refactor a load realisations event;
		var e = document.createEvent("CustomEvent");
		e.initCustomEvent('realisation_list_call', false, false, {});
    window.dispatchEvent(e);
  }


  /**
   * click on realisation goto previous
   */
  clickOnRealisationGotoPrevious(e) {
    e.preventDefault();
    console.log('pass in click on realisation goto previous link');
    // @TODO: Refactor a load realisations event;
		var e = document.createEvent("CustomEvent");
		e.initCustomEvent('realisation_previous_call', false, false, {
			'realisation': this
		});
    window.dispatchEvent(e);
  }



  /**
   * click on realisation goto next
   */
  clickOnRealisationGotoNext(e) {
    e.preventDefault();
    console.log('pass in click on realisation goto next link');
    // @TODO: Refactor a load realisations event;
		var e = document.createEvent("CustomEvent");
		e.initCustomEvent('realisation_next_call', false, false, {
			'realisation': this
		});
    window.dispatchEvent(e);
  }


  /**
   * Go
   */
  go() {
    this.ajax("/wp-json/wp/v2/realisations/" + this.postId).then(
      function(result) {
        this.data = JSON.parse(result);
        this.getPrevPostId();
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });
  }


  /**
   * Get prev post id
   */
  getPrevPostId() {
    this.ajax("/wp-content/themes/pepscreation/prev-realisation-id.php?id=" + this.postId).then(
      function(result) {
        this.data.prevRealisationId = "";
        if (!isNaN(result)) {
          this.data.prevRealisationId = result;
        }
        this.getNextPostId();
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });
  }


  /**
   * Get next post id
   */
  getNextPostId() {
    this.ajax("/wp-content/themes/pepscreation/next-realisation-id.php?id=" + this.postId).then(
      function(result) {
        this.data.nextRealisationId = "";
        if (!isNaN(result)) {
          this.data.nextRealisationId = result;
        }
        this.display();
      }.bind(this)
    ).catch(function(msg) {
      console.log(msg);
    });
  }


  /**
   * Display
   */
  display(){

    var realisationContentTemplate = "";

    if(this.data.content.rendered) {
      var content = this.data.content.rendered
        .replace(/\+\+\+/gi, '<hr>')
        .replace(/\<\p\>/gi, '')
        .replace(/\<\/\p\>/gi, '');
      var doc = document.createElement("div");
      doc.innerHTML = content;
      var breakers = doc.getElementsByTagName('hr');
      for(var i=0;i<breakers.length;i++){
        var nextEl = breakers[i].nextSibling;
        var prevEl = breakers[i].previousSibling;
        var element = document.createElement('div');
        doc.appendChild(element);
        prevEl.parentNode.insertBefore(element, prevEl);
        element.appendChild(prevEl);
        element.appendChild(nextEl);
      }
      while (breakers.length > 0) {
        breakers[0].parentNode.removeChild(breakers[0]);
      }
      realisationContentTemplate = doc.innerHTML;
    }

    var prevRealisationTemplate = ``;
    if(this.data.prevRealisationId){
      console.log('prev realisation id ok');
      prevRealisationTemplate = `
      <a data-id="${this.data.prevRealisationId}"
      href="javascript: void(0);"
      title"Précédent" class="nav-arrow" id="nav-p">
      <img class="nav-arrow-m"
      src="/wp-content/themes/pepscreation/img/prev-m.png" alt="prev">
      <img class="nav-arrow-d"
      src="/wp-content/themes/pepscreation/img/prev-d.png" alt="prev">
      </a>
      `;
    }

    var nextRealisationTemplate = ``;
    if(this.data.nextRealisationId){
      console.log('next realisation id ok');
      nextRealisationTemplate = `
      <a data-id="${this.data.nextRealisationId}"
      href="javascript: void(0);"
      title"Suivant" class="nav-arrow" id="nav-n">
      <img class="nav-arrow-m"
      src="/wp-content/themes/pepscreation/img/next-m.png" alt="next">
      <img class="nav-arrow-d"
      src="/wp-content/themes/pepscreation/img/next-d.png" alt="next">
      </a>
      `;
    }

    var template = ``;

    template += `
      <div id="realisation-page" class="page">
      <nav>
      ${prevRealisationTemplate}
      ${nextRealisationTemplate}
      </nav>
      <section id="realisation-header" class="page">
        <h1 class="title">${this.data.title.rendered}</h1>
        <h2>${this.data.acf.text}</h2>
        <div id="intro-text">${this.data.acf.intro_text}</div>
      `;

    /*if (this.data.acf.intro_text){
    template += `
      <p>${this.data.acf.intro_text}</p>
      `;
    }*/

    template += `
      </section>`;

    template += `
      <section id="realisation-content">
      ${realisationContentTemplate}
      </section>
      <section id="realisation-fin">
      <div id="fin-text">
      ${this.data.acf.texte_fin}
      </div>
    <a id="realisation-goto-shops-border-fill-button"
      class="border-fill-button inverted blocked-mobile-border arrow-link"
      href="/realisations">
      <svg xmlns="http://www.w3.org/2000/svg">
      <rect
      stroke="#5f5a58"
      stroke-width="5"
      fill="transparent"
      stroke-dasharray="1610"
      stroke-dashoffset="1610"
      height="100%"
      width="100%"
      stroke-opacity="1"/>
      </svg>
      <span>Voir toutes nos boutiques</span>
      </a>
      </section>
      </div>
      `;

    // set page meta
    if (this.currentPageId) {
      document.getElementById(this.currentPageId)
        .setAttribute("id", "realisation-page-container");
      this.currentPageId = "realisation-page-container";
    } else {
      return false;
    }

    // Send built event
		var e = document.createEvent("CustomEvent");
		e.initCustomEvent('page_built', false, false, {
			'slug': this.data.link,
      'template': template
		});
    window.dispatchEvent(e);
  }

}

export default Realisation;
